import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './slideAnimation.module.scss'

class SlideAnimation extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        direction: PropTypes.oneOf(['left', 'right']),
        type: PropTypes.oneOf(['in', 'out']),
        visible: PropTypes.bool.isRequired,
    }

    render() {
        const { children, className, direction, type, visible, ...rest } =
            this.props

        return (
            <div
                className={cx(className, {
                    [styles.visibleSlide]: visible,
                    [styles.hiddenSlide]: !visible,
                })}
                {...rest}
            >
                <div
                    className={cx({
                        [styles.slideInAnimation]: type === 'in',
                        [styles.slideInFromLeft]:
                            direction === 'left' && type === 'in',
                        [styles.slideInFromRight]:
                            direction === 'right' && type === 'in',
                        [styles.slideOutToLeftAnimation]:
                            type === 'out' && direction === 'left',
                        [styles.slideOutToRightAnimation]:
                            type === 'out' && direction === 'right',
                    })}
                >
                    {children}
                </div>
            </div>
        )
    }
}

export default SlideAnimation
